import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { RiFileCopyFill } from "react-icons/ri";
import { useState } from "react";
import Rating from '@mui/material/Rating';
import { formatDateTime } from '../utils/FormateDate';
import FormatPrice from '../utils/FormatePrice';
import Star from '../assets/images/vector.png'

const ReviewDrawer = ({ isOpen, onClose, item }) => {
  const [textToCopy, setTextToCopy] = useState('');
  const [copyStatus, setCopyStatus] = useState(false);

  const onCopyText = () => {
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 2000);
  };
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} size='md'
    slotProps={{
      root: {
        className: `
          backdrop-blur-[1px] 
          bg-orange/20 
          rounded-tl-2xl 
        `,
      },
    }}  
    >
      <ModalClose />
          <div className="p-5">
            <p type="h6" className="capitalize text-[24px] font-bold text-primaryRed pt-5">Detailed Review Overview</p>

          <p className="my-2 text-foreground text-sm text-[#0A0A0ACC]">
          Get a complete view of customer feedback to understand experiences better and take actions that enhance service quality.     </p>
          {item?.entity === "Food" 
            ? (
            <div className="mt-4 space-y-4">
              <div className="mt-4 rounded-lg border px-3">
                <div className="flex justify-center items-center my-2">
                  <div className="flex items-center bg-black text-white px-3 py-1.5 rounded-md mb-4">
                    <p className="text-sm">
                      Customer Review
                    </p>
                    <div className="ml-5 flex items-center">
                      <img src={Star} alt='' className='w-1/2' />
                      <span className='ml-2 text-sm'>{item?.rating}</span>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-3">
                  <p className="text-sm text-[#0A0A0A] opacity-80">Category Name</p>
                  <p className="text-sm font-medium">{item?.reviewForFood?.categoryName}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className="flex justify-between items-center mt-3">
                  <p className="text-sm text-[#0A0A0A] opacity-80">Date and Time</p>
                { item?.reviewForFood?.createdOn && (
                    <p className="text-sm font-medium">{formatDateTime(item?.reviewForFood?.createdOn)}</p>
                  )}
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className="flex justify-between items-center mt-3">
                  <p className="text-sm text-[#0A0A0A] opacity-80">Price</p>
                    <p className="text-sm font-medium">{FormatPrice(item?.reviewForFood?.price)}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                <div className='flex items-center mt-3 justify-between'>
                  <p className="text-sm text-[#0A0A0A] opacity-80">Ingredents</p>
                  <p className="text-sm font-medium">{item?.reviewForFood?.ingredientDetails}</p>
                </div>
                <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              </div>
              <div className="mt-10 rounded-lg border px-3 pb-4">
                <div className="flex justify-between items-center bg-primaryGray/50 py-2 px-2 mt-2 rounded-tl-md rounded-tr-md">
                  <p className="text-sm text-[#0A0A0A] opacity-80">Cutomer Name</p>
                  <p className="text-sm font-medium">{item?.reviewedBy}</p>
                </div>
                <div className="flex justify-between items-center bg-primaryGray/50 mt-[1px] py-2 px-2">
                  <p className="text-sm text-[#0A0A0A] opacity-80">Rating</p>
                  <Rating name="read-only" value={item.rating} readOnly />
                </div>
                <div className='mt-3'>
                  <p className="text-sm font-medium">Customer Reviews</p>
                  <div className='bg-orange p-2 rounded-md mt-2 shadow-md'>
                   {item?.reviewSummary &&
                    <p className="text-sm">{item?.reviewSummary}</p>
                  }
                  </div>
                </div>
              </div>
              <button
                  className="bg-[#FF0000] hover:bg-opacity-50 rounded-md py-2 text-white w-full outline-none ring-0 border border-primaryRed hover:bg-white hover:text-primaryRed hover:outline-none capitalize mt-6 focus:outline-none"
                >Respond To Review </button>
            </div>
            ) : (
              item?.entity === "Agent" &&
                <div className="mt-4 space-y-4">
                <div className="mt-4 rounded-lg border px-3">
                  <div className="flex justify-center items-center mt-2">
                    <div className="flex items-center bg-black text-white px-3 py-1.5 rounded-md">
                      <p className="text-sm">
                        Delivery Agent
                      </p>
                      <div className="ml-5">
                        <Rating name="read-only" value={item.rating} readOnly />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center mt-3">
                    <p className="text-xs text-[#0A0A0A] opacity-80">Name</p>
                    <p className="text-xs font-medium">{item?.reviewForAgent?.name}</p>
                  </div>
                  <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                  <div className="flex justify-between items-center mt-3">
                    <p className="text-xs text-[#0A0A0A] opacity-80">identification number</p>
                    <p className="text-xs font-medium">{item?.reviewForAgent?.identityNumber}</p>
                  </div>
                  <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                  <div className="flex justify-between items-center mt-3">
                    <p className="text-xs text-[#0A0A0A] opacity-80">contact number</p>
                    <div className='flex items-center my-1'>
                      <p className="text-xs font-medium">{item?.reviewForAgent?.phoneNumber}</p>
                      <CopyToClipboard text={textToCopy} onCopy={onCopyText}>
                        <RiFileCopyFill class="text-gray-400 ml-1 cursor-pointer" />
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                  <div className='flex items-center mt-3 justify-between'>
                    <p className="text-xs text-[#0A0A0A] opacity-80">Email</p>
                    <p className="text-xs font-medium">{item?.reviewForAgent?.emailAddress}</p>
                  </div>
                  <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
                </div>
                <div className="mt-10 rounded-lg border px-3 pb-4">
                  <div className="flex justify-between items-center bg-primaryGray/50 py-2 px-2 mt-2 rounded-tl-md rounded-tr-md">
                    <p className="text-xs text-[#0A0A0A] opacity-80">Agent Name</p>
                    <p className="text-xs font-medium">{item?.reviewForAgent?.reviewedBy}</p>
                  </div>
                  <div className="flex justify-between items-center bg-primaryGray/50 mt-[1px] py-2 px-2">
                    <p className="text-xs text-[#0A0A0A] opacity-80">Rating</p>
                    <Rating name="read-only" value={item.rating} readOnly />
                  </div>
                  <div className='mt-3'>
                    <p className="text-sm font-medium">Agent Review</p>
                    <div className='bg-orange p-2 rounded-md mt-2 shadow-md'>
                      <p className="text-xs">{item?.reviewSummary}</p>
                    </div>
                  </div>
                </div>
                <button
                    className="bg-[#FF0000] hover:bg-opacity-50 rounded-md py-2 text-white w-full outline-none ring-0 border border-primaryRed hover:bg-white hover:text-primaryRed hover:outline-none capitalize mt-6 focus:outline-none"
                  >Respond To Review </button>
                </div>
            )
          }
        </div>
    </Drawer>
  );
}

export default ReviewDrawer;